import React from "react";
import "./BecomePartner.css";

const Partner: React.FC = () => {
  return (
    <section id="partner" className="partner">
      <div className="partner-container">
        <h2 className="ar-content">كن شريكاً</h2>
        <h2 className="en-content">Become a Partner</h2>
        <div className="partner-content">
          <div className="partner-text">
            <p className="ar-content">
              انضم إلى أكاديمية الذكاء الاصطناعي لتعزيز الابتكار والتعليم في
              مجال الذكاء الاصطناعي. تم تصميم برنامج الشراكة لدينا لخلق علاقات
              متبادلة المنفعة تعزز تعليم وتطبيق الذكاء الاصطناعي.
            </p>
            <p className="en-content">
              Join forces with AI Academy to foster innovation and education in
              the field of artificial intelligence. Our partnership program is
              designed to create mutually beneficial relationships that advance
              AI education and application.
            </p>
            <p className="ar-content">
              سواء كنت شركة تتطلع إلى تعزيز قدراتك في مجال الذكاء الاصطناعي، أو
              مؤسسة تعليمية تسعى إلى توسيع مناهجك الدراسية، أو منظمة ذات رؤية
              مشتركة لتطوير الذكاء الاصطناعي، نرحب بتعاونك.
            </p>
            <p className="en-content">
              Whether you're a business looking to enhance your AI capabilities,
              an educational institution seeking to expand your curriculum, or
              an organization with a shared vision for AI advancement, we
              welcome your collaboration.
            </p>
            <p className="ar-content">
              كشريك، ستتمكن من الوصول إلى شبكتنا من خبراء الذكاء الاصطناعي،
              والمشاركة في المبادرات المشتركة، والمساهمة في تشكيل مستقبل تعليم
              وابتكار الذكاء الاصطناعي.
            </p>
            <p className="en-content">
              As a partner, you'll gain access to our network of AI experts,
              participate in joint initiatives, and contribute to shaping the
              future of AI education and innovation.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partner;
